/* Accessibility labels for third-party widgets; no visual or interaction changes. */
(() => {
  const observed = new WeakSet();
  const selector = '#merchantwidgetiframe, #whatsappIconWidget, #prevBtn, #nextBtn';
  function label(element) {
    if (element.id === 'merchantwidgetiframe' && !element.title) element.title = 'Google store ratings';
    if (element.id === 'whatsappIconWidget' && !element.hasAttribute('alt')) element.alt = 'WhatsApp support';
    if ((element.id === 'prevBtn' || element.id === 'nextBtn') && !element.hasAttribute('aria-label')) {
      element.setAttribute('aria-label', element.id === 'prevBtn' ? 'Previous customer reviews' : 'Next customer reviews');
    }
  }
  function scan(root) {
    if (root.matches?.(selector)) label(root);
    root.querySelectorAll?.(selector).forEach(label);
    const host = document.getElementById('carthike-carousel-div');
    if (host?.shadowRoot) observe(host.shadowRoot);
  }
  function observe(root) {
    if (observed.has(root)) return;
    observed.add(root);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) scan(node);
      }));
    }).observe(root, {childList: true, subtree: true});
    scan(root);
  }
  observe(document.body);
  // Review apps can attach a shadow root after their host is inserted.
  [500, 1500, 5000].forEach(delay => setTimeout(() => scan(document.body), delay));
})();
